package br.com.texeratx.boardgametimeapp.data.repository

import br.com.texeratx.boardgametimeapp.core.network.ApiClient
import br.com.texeratx.boardgametimeapp.core.session.SessionManager
import br.com.texeratx.boardgametimeapp.data.model.expansion.CreateExpansionRequest
import br.com.texeratx.boardgametimeapp.data.model.expansion.ExpansionDTO
import br.com.texeratx.boardgametimeapp.data.model.expansion.UpdateExpansionRequest
import io.ktor.client.call.body

class ExpansionRepository(
    private val api: ApiClient,
    private val sessionManager: SessionManager
) {

    suspend fun getExpansionsByIds(ids: List<Long>): Result<List<ExpansionDTO>> {
        return try {
            sessionManager.load() ?: return Result.failure(Exception("Sessão expirada"))
            val idsParam = ids.joinToString(",")
            val response = api.get("expansions?ids=$idsParam")
            Result.success(response.body())
        } catch (e: Exception) {
            Result.failure(e)
        }
    }

    suspend fun getExpansionsByGame(gameId: Long): Result<List<ExpansionDTO>> {
        return try {
            sessionManager.load()
                ?: return Result.failure(Exception("Sessão expirada"))

            val response = api.get("expansions/game/$gameId")
            Result.success(response.body())
        } catch (e: Exception) {
            Result.failure(e)
        }
    }

    suspend fun createExpansion(body: CreateExpansionRequest): Result<ExpansionDTO> {
        return try {
            sessionManager.load() ?: return Result.failure(Exception("Sessão expirada"))
            val response = api.post("expansions", body)
            Result.success(response.body())
        } catch (e: Exception) {
            Result.failure(e)
        }
    }

    suspend fun getAllExpansions(): Result<List<ExpansionDTO>> {
        sessionManager.load() ?: return Result.failure(Exception("Sessão expirada"))
        return try {
            val response = api.get("expansions")
            Result.success(response.body())
        } catch (e: Exception) {
            Result.failure(e)
        }
    }

    suspend fun getExpansionById(id: Long): Result<ExpansionDTO> {
        return try {
            sessionManager.load() ?: return Result.failure(Exception("Sessão expirada"))
            val response = api.get("expansions/$id")
            Result.success(response.body())
        } catch (e: Exception) {
            Result.failure(e)
        }
    }

    suspend fun updateExpansion(id: Long, body: UpdateExpansionRequest): Result<ExpansionDTO> {
        sessionManager.load() ?: return Result.failure(Exception("Sessão expirada"))
        return try {
            val response = api.put("expansions/$id", body)
            Result.success(response.body())
        } catch (e: Exception) {
            Result.failure(e)
        }
    }
}
